import { useSettings } from "./settings";

// Website defaults – every text can be overridden in Backoffice → Einstellungen (empty field = default).
export const TEXT_DEFAULTS = {
  tour_good_to_know_title: "Gut zu wissen",
  tour_good_to_know: [
    "Kosten: keine – alle Touren sind kostenlos.",
    "Für wen: nur für Erwachsene, keine Vorkenntnisse nötig.",
    "Dauer & Gruppe: ca. 3 Stunden, höchstens 15 Personen.",
    "Sprache: Luxemburgisch und Deutsch.",
    "Mitbringen: feste Schuhe, wetterfeste Kleidung, etwas zu trinken. Lupen und Material stellen wir.",
    "Wetter: Regen ist kein Problem. Abgesagt wird nur bei Gewitter, Sturm oder ab MeteoLux-Warnstufe Orange – wir informieren dich rechtzeitig.",
    "Barrierefreiheit: Die Touren sind leider nicht barrierefrei (unebener Waldboden).",
    "Hunde: Bitte keine Hunde – Assistenzhunde sind willkommen.",
    "Allergien: Bei Milchallergie oder -unverträglichkeit sag uns bei der Anmeldung Bescheid.",
    "Treffpunkt: Den genauen Treffpunkt bekommst du mit deiner Anmeldebestätigung.",
  ].join("\n"),
  tour_dont_do_overline: "Unsere Haltung",
  tour_dont_do_title: "Was wir nicht tun",
  tour_dont_do_items: [
    "Keine Pflanzen aus Naturschutzgebieten – unsere Kräuter kommen aus dem Kräutergarten.",
    "Kein Plastik bei unseren Mitbringseln.",
    "Keine Kosten – unsere Touren sind kostenlos.",
  ].join("\n"),
  tour_dont_do_closing: "Klein anfangen. Natur schützen.",
  tour_dont_do_image: "/fotos/korb-nah.webp",
  tour_dont_do_image_alt: "Korb mit Kräutern aus dem eigenen Kräutergarten",
  tour_herb_note: "Die Kräuter für Kostproben kommen aus unserem Kräutergarten. In Naturschutzgebieten wird nichts gepflückt.",
  tour_no_dates_text: "Die nächsten Termine folgen bald. Trag dich in den Newsletter ein – wir melden uns, sobald die nächste Tour steht.",
  tour_meeting_hint: "Den genauen Treffpunkt bekommst du mit deiner Anmeldebestätigung.",
  tour_badges: ["Kostenlos", "Nur Erwachsene", "ca. 3 Std.", "max. 15 Pers."].join("\n"),
  contact_topics: ["Frage zu einer Tour", "Frage zu Pflanzen", "Kooperation / Presse", "Sonstiges"].join("\n"),
  contact_privacy_text: "Ich habe die Datenschutzerklärung gelesen und bin einverstanden, dass meine Angaben zur Beantwortung meiner Anfrage gespeichert werden.",
  contact_success_text: "Danke für deine Nachricht! Wir melden uns so schnell wie möglich.",
  contact_direct_text: "Fragen zu den Naturwanderungen:",
  footer_tours_email: "natur@adventurecouple.lu",
  footer_more_info_label: "adventurecouple.lu",
  footer_more_info_url: "https://adventurecouple.lu",
};

export const MONTH_PHOTO_DEFAULTS = [
  ["winter-pause", "Pause am moosbewachsenen Baumstamm", "Winterruhe im Wald"],
  ["jahresringe", "Jahresringe eines gefällten Baumes", "Der Wald sammelt Kraft"],
  ["kraeuter-hand", "Frisch gesammelte Wildkräuter in der Hand", "Die ersten Kräuter"],
  ["baerlauch-sammeln", "Bärlauch wird einzeln von Hand gesammelt", "Bärlauch-Zeit"],
  ["hummel", "Hummel an einer Blüte", "Alles summt und blüht"],
  ["korb-schafgarbe", "Korb mit frisch gesammelten Wildkräutern", "Kräuter in Fülle"],
  ["kraeuter-schneiden", "Kräuter werden fein geschnitten", "Sommerküche"],
  ["fluss", "Bachlauf im Wald im Spätsommer", "Kühle Ufer, späte Blüten"],
  ["springkraut", "Blühendes Drüsiges Springkraut", "Spätsommer an Bach und Ufer"],
  ["hagebutte", "Rote Hagebutte in der Hand", "Früchte der Hecke"],
  ["nebelwald", "Waldweg im herbstlichen Nebel", "Nebel und Stille"],
  ["kraeutersalz", "Selbst gemachtes Wildkräutersalz im Glas", "Vorrat aus dem Sommer"],
].map(([f, alt, mood]) => ({ url: `/fotos/${f}.webp`, alt, mood }));

export const lines = (txt) => (txt || "").split("\n").map((l) => l.trim()).filter(Boolean);

export const labelLines = (txt) => lines(txt).map((l) => {
  const i = l.indexOf(":");
  return i > 0 ? [l.slice(0, i).trim(), l.slice(i + 1).trim()] : ["", l];
});

export function siteText(s, key) {
  const v = s?.[key];
  return typeof v === "string" && v.trim() ? v : TEXT_DEFAULTS[key];
}

export function useSiteText() {
  const s = useSettings();
  return (key) => siteText(s, key);
}

export function monthPhoto(s, month) {
  const own = (s?.calendar_month_photos || [])[month - 1] || {};
  const def = MONTH_PHOTO_DEFAULTS[month - 1];
  return { url: own.url || def.url, alt: own.alt || def.alt, mood: own.mood || def.mood };
}
